import React from "react";
import { Paper, Typography, Box, TextField, Button, Divider } from "@mui/material";

const OrderSummary = ({plan}) => {

  return (
    <Paper sx={{ p: 4, borderRadius: 2 , mb:8}}>
      <Typography variant="h3" gutterBottom sx={{mb:3}}>Order summary</Typography>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography>Plan</Typography>
        <Typography fontWeight="bold">{plan.name}</Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography>Subtotal</Typography>
        <Typography>₹{plan.price}</Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography>Estimated tax</Typography>
        <Typography>₹0</Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography fontWeight="bold">Total due today</Typography>
        <Typography fontWeight="bold">₹{plan.price}</Typography>
      </Box>
      <Typography variant="caption" color="text.secondary">
        * Taxes such as GST/VAT may apply depending on your location.
      </Typography>
    </Paper>
  );
};

export default OrderSummary;
